import {
  initialSubscriptionsState,
  initialFiltersState,
  FiltersState,
  SubscriptionState
} from '../modules/subscriptions/store/store'

import { ReportsState, initialReportsState } from '../modules/reports/store/store'
import { DashboardState, initialDashboardState } from '../modules/dashboard/store/store'
import { AuthState, initialAuthState } from './auth/store/store'
import { SearchState, initialSearchState } from './nav/store/store'
import { DiagsState, initialDiagsState } from './diags/store/store'
import { AccountsState, initialAccountsState } from '../modules/accounts/store/store'
import { PartnerState, initialPartnerState } from './partner/store/store'
import { initialSettingsState, SettingsState } from '../modules/settings/_root/store/store'

export type AppState = {
  auth: AuthState
  search: SearchState
  dashboard: DashboardState
  diags: DiagsState
  filters: FiltersState
  subscriptions: SubscriptionState
  accounts: AccountsState
  reports: ReportsState
  partner: PartnerState
  settings: SettingsState
}

export const initialAppState: AppState = {
  auth: initialAuthState,
  search: initialSearchState,
  diags: initialDiagsState,
  filters: initialFiltersState,
  subscriptions: initialSubscriptionsState,
  accounts: initialAccountsState,
  reports: initialReportsState,
  dashboard: initialDashboardState,
  partner: initialPartnerState,
  settings: initialSettingsState
}
